module.exports = __webpack_public_path__ + "img/philosophy@2x.9771202.webp";